export const mapOrderStatus = (status?: string) => {
    switch (status) {
        case 'Completed':
            return 'completed';

        case 'Cancelled':
            return 'cancelled';

        case 'Open':
            return 'open';

        default:
            return '';
    }
};
